import { ReactComponent as CheckCircleIcon } from '../../assets/icons/check-circle-icon.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/x-icon.svg';
import { useEffect } from 'react';

const NotificationModal = ({ closeModal, duration = 3000, type, title, subTitle }) => {
  useEffect(() => {
    const timer = setTimeout(() => closeModal(), duration);
    return () => clearTimeout(timer);
  }, [closeModal, duration]);

  return (
    // <div style={styles.modalOverlay} onClick={() => closeModal()}>
        <div style={{...styles.modalContainer, 
            borderColor: type?.toLowerCase() === "success" ? "#A2D78C" : type?.toLowerCase() === "error" ? "#D78C8C" : "#FFCC00",
            backgroundColor: type?.toLowerCase() === "success" ? "#F3FFEE" : type?.toLowerCase() === "error" ? "#FFECEC" : "#FFFFFF"}} 
            onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <span style={styles.title}>
            {
              type?.toLowerCase() === "success" && (
                <CheckCircleIcon color='#65B544' size={24}/>
              )
            }
              {title}
            </span>
            <button
                onClick={closeModal}
                className='modal-header-close-button'
                onMouseEnter={(e) => (e.currentTarget.style.color = "#4b5563")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#9ca3af")}
            >
                <CloseIcon size={24} />
            </button>
          </div>

          {
            subTitle &&
              <div style={{}}>
                <span style={styles.subTitle}>
                  {subTitle}
                </span>
              </div>
          }
          
        </div>
    // </div>
  );
};

export default NotificationModal;

const styles = {
  modalOverlay: {
    position: "fixed",
    top: "60px",
    right: "16px",
    width: "100%",
    height: "100%",
    zIndex: 1000,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-start",
  },
  modalContainer: {
    minWidth: "320px", 
    maxWidth: "640px", 
    padding: "20px 24px", 
    borderRadius: "20px",
    border: "2px solid #A2D78C", 
    boxShadow: "0px 6px 12px 0px #0000001A", 
    background: "#F3FFEE"
  },
  title:{
    color: "#010101",
    fontWeight: "600",
    fontSize: "18px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 8,
  },
  subTitle: {
    color: "#6D6D6D",
    fontWeight: "400",
    fontSize: "16px",
    whiteSpace: "pre-line" 
  }
};